import { Inject, Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { JwtHelperService } from '@auth0/angular-jwt';
import { CookieService } from 'ngx-cookie-service';
import { Env } from '@usimweb/core/models';

export interface FederationServiceConfiguration {
  issuer: string;
  authorization_endpoint: string;
  token_endpoint: string;
}

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private helper: JwtHelperService = new JwtHelperService();

  public userSet = new BehaviorSubject<boolean>(false);
  public static userName = '';
  public static basfUserName = '';
  public static firstName: string = '';
  public static lastName: string = '';
  public static mail: string = '';

  constructor(
    @Inject('environment') private environment: Env,
    private cookieService: CookieService
  ) {}

  private setUsername() {
    const accessToken = this.cookieService.get('access_token');
    const decodedToken = this.helper.decodeToken(accessToken);

    if (accessToken) {
      const firstName = decodedToken['firstName'] || '';
      const lastName = decodedToken['lastName'] || '';
      const mail = decodedToken['mail'] || '';

      AuthService.userName = firstName + ' ' + lastName;
      AuthService.basfUserName = '';
      AuthService.firstName = firstName;
      AuthService.lastName = lastName;
      AuthService.mail = mail;

      const cname = decodedToken['cn'];

      if (typeof cname === 'string') {
        AuthService.basfUserName = cname;
        // } else if (cname instanceof String) {
        //   AuthService.basfUserName = cname.toString();
      } else if (Array.isArray(cname)) {
        AuthService.basfUserName = cname[0];
      }
      this.userSet.next(true);
    }
  }

  public authenticate() {
    if (this.accessToken && !this.isTokenExpired()) {
      console.log('you already logged in, tokens are still valid');
    } else {
      this.redirect();
    }
  }

  public redirect() {
    if (location.hostname !== 'localhost') {
      location.href = this.environment.redirectUri;
    } else {
      alert('fetching authcode failed you are local host');
    }
  }

  public isAuthenticated() {
    if (this.accessToken && !this.isTokenExpired()) {
      return true;
    }
    return false;
  }

  public get accessToken(): string {
    this.setUsername();
    return this.cookieService.get('access_token');
  }

  public isTokenExpired(): boolean {
    let isExpired = true;

    if (this.accessToken) {
      // for jwt token
      isExpired = this.helper.isTokenExpired(this.accessToken, 60);
    }
    return isExpired;
  }

  public get isLoggedIn(): boolean {
    try {
      if (this.decodedToken) {
        return this.decodedToken.hasOwnProperty('mail');
      }
      return false;
    } catch (error) {
      return false;
    }
  }

  public get decodedToken() {
    return this.helper.decodeToken(this.accessToken);
  }

  public logout() {
    this.cookieService.delete('access_token', '/');
    this.cookieService.delete('refresh_token', '/');
    const url = this.environment.redirectUri + '/' + this.environment.APP;
    window.open(url, '_self');
  }
}
